var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centerer"},[_c('h1',[_vm._v("Logging out...")]),_c('a-spinner',{attrs:{"big":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }